import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsInvoiceEmpPending } from "shared/redux/common-reducer";
import { Button, Modal } from "antd";
import { useHistory } from "react-router-dom";

interface ICloseWarningEmp {
  closeWarningEmpLocation: string;
  setCloseWarningEmplocation: (value: React.SetStateAction<string>) => void;
  callBack?: any;
}

const CloseWarningEmp: React.FC<ICloseWarningEmp> = (props: ICloseWarningEmp) => {
  const { closeWarningEmpLocation, setCloseWarningEmplocation, callBack } = props;

  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <Modal
      title=""
      centered
      width={400}
      closable={false}
      footer={null}
      visible={closeWarningEmpLocation?.length > 0}
    >
      <div className="delete-modal">
        <span>
          {
            "Unsaved changes will be lost. Are you sure you want to proceed?"
          }
        </span>
        <div className="delete-modal-btn">
          <Button
            className="app-btn-border"
            onClick={() => setCloseWarningEmplocation("")}
          >
            Close
          </Button>
          <Button
            className="app-btn-primary-bg"
            onClick={() => {
              dispatch(setIsInvoiceEmpPending(false));
              setCloseWarningEmplocation("");
              if (closeWarningEmpLocation.includes("/")) {
                history.push(closeWarningEmpLocation);
              } else {
                callBack(closeWarningEmpLocation)
              }
            }}
          >
            Proceed
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CloseWarningEmp;
